import React from 'react'
import { useIntl } from 'react-intl'
import Pane from 'components/Common/Pane'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  className?: string
}

function LastMinuteSummary(props: Props) {
  const {
    className,
  } = props

  const intl = useIntl()

  return (
    <Pane
      border="neutral-six"
      borderRadius="XS"
      padding="28 20"
      shadow="bottom-small"
      className={className}
      data-testid="SummaryPane"
    >
      <VerticalSpacer gap={12}>
        <BodyText
          variant="large"
          data-testid="OfferSoldOut"
          weight="bold"
        >
          {intl.formatMessage({
            id: '08JPVzl7IKGX8DvGySAw',
            defaultMessage: 'This offer has SOLD OUT',
            description: 'Message displayed when a last minute offer has sold out',
          })}
        </BodyText>
        <TextButton
          kind="primary"
          to="/"
          fit="flex"
        >
          {intl.formatMessage({
            id: 'FPW_ZEOgLf_H9JIcwpPc',
            defaultMessage: 'Browse all offers',
            description: 'Action button label to navigate to browse all offers page',
          })}
        </TextButton>
      </VerticalSpacer>
    </Pane>
  )
}

export default LastMinuteSummary
